import { render, staticRenderFns } from "./FunctionLoggingPage.vue?vue&type=template&id=8b5c358c&scoped=true&"
import script from "./FunctionLoggingPage.vue?vue&type=script&lang=js&"
export * from "./FunctionLoggingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5c358c",
  null
  
)

export default component.exports